export default async function(context) {
  const { app, $auth, route } = context;

  if (!$auth.loggedIn) {
    app.$cookies.set("deepLinkUrl", route.fullPath);
  }
}
